module.exports = __webpack_public_path__ + "img/[吓].2088c1ff.svg";